<div class="auth-otp-verify-form-container mb-5">
  <div class="flex flex-col gap-4 sm:w-[400px] sm:gap-6">
    <button
      class="back-button flex w-fit items-center gap-[6px] p-2 pl-0 text-brand-primary-800"
      type="button"
      (click)="goBack()"
    >
      <aw-icon class="w-5" icon="arrow-left" />
      <span class="font-medium">Back</span>
    </button>

    <div class="flex w-full flex-col gap-2">
      <h2 class="text-2xl font-medium leading-9 text-brand-accent-400">
        We’ve sent you a verification code
      </h2>

      <p class="text-sm leading-5 text-po-grey-5">
        You should receive it shortly at {{ email() }}
      </p>
    </div>

    <form
      class="w-full"
      [formGroup]="otpForm"
      [class.form-otp-invalid]="formOtpInvalid()"
    >
      <div class="mb-2 flex justify-center">
        <div class="flex w-full justify-start gap-3">
          @for (digit of otpDigitsIndexes; track digit) {
            <input
              #otpInput
              class="h-10 w-10 select-none text-center text-sm font-semibold focus:ring-transparent sm:h-12 sm:w-12"
              maxlength="1"
              inputmode="numeric"
              autocomplete="one-time-code"
              placeholder=""
              pattern="[0-9]"
              type="text"
              [attr.data-index]="digit"
              [value]="otpDigits()[digit] || ''"
              [disabled]="isLoading() || formDisabled()"
              (input)="onDigitInput($event, digit)"
              (keydown)="onKeyDown($event, digit)"
              (paste)="onPaste($event, digit)"
            />
          }
        </div>
      </div>

      @if (formOtpInvalid()) {
        <ng-container [ngTemplateOutlet]="genericErrorsTemplate" />
      }

      <po-button
        class="btn-submit mt-10 inline-block"
        variant="authResend"
        businessUnit="blocks"
        buttonText="Resend code"
        size="small"
        type="button"
        [class.btn-submit--disabled]="formDisabled()"
        [loading]="isResending()"
        [disabled]="isLoading() || resendCountdown() > 0 || formDisabled()"
        (clicked)="resendCode()"
      >
        <span>
          @if (resendCountdown() > 0 && !formDisabled()) {
            Resend in
            <span class="inline-block w-8 text-center">{{
              resendCountdownFormatted()
            }}</span>
          } @else {
            Resend code
          }
        </span>
      </po-button>
    </form>

    <!-- Auth Error Display -->
    <ng-container [ngTemplateOutlet]="authErrorsTemplate" />
  </div>
</div>

<ng-template #genericErrorsTemplate>
  @if (error()?.message && error()?.code !== errorCodes.AccountAlreadyExists) {
    <div class="bg-po-grey-6/85 w-auto rounded-lg p-2 text-sm text-po-red-400">
      @switch (error()?.code) {
        @case (errorCodes.LoginOtpCodeInvalid) {
          The code you entered is invalid.<br />
          Try entering it again or resend a new one.
        }
        @case (errorCodes.RegisterOtpCodeInvalid) {
          The code you entered is invalid.<br />
          Try entering it again or resend a new one.
        }
        @case (errorCodes.AccountDoesntExist) {
          The code you entered is invalid.<br />
          Try entering it again or resend a new one.
        }
        @default {
          {{ error()!.message }}
        }
      }
    </div>
  }
</ng-template>

<ng-template #authErrorsTemplate>
  @if (error()?.message) {
    @if (error()?.code === errorCodes.AccountAlreadyExists) {
      <div class="bg-po-grey-6/85 rounded-lg p-2 text-sm text-po-red-400">
        The email is already linked to an account.<br />
        Please use a new email to register or
        <po-button
          class="-ml-1 inline-block w-fit"
          variant="error-link"
          buttonText="Login"
          size="small"
          [path]="loginRoute"
          [queryParams]="
            formEmail()
              ? {
                  email: formEmail()!
                }
              : {}
          "
          [replaceUrl]="true"
          >login here</po-button
        >
      </div>
    }
  }
</ng-template>
